import * as icons from '@creditornot/alchemy-react/icons';
import { Button } from '@creditornot/cb-button';
import { FloatingIsland } from 'common/components/cookbook/FloatingIsland/FloatingIsland';
import { Stack } from 'common/components/cookbook/Stack';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

type Props = {
  isVisible: boolean;
  handleRejectionModalOpen: () => void;
  handleApprovalModalOpen: () => void;
  approvalIsLoading?: boolean;
};

export const ActionSelect = ({
  isVisible,
  handleRejectionModalOpen,
  handleApprovalModalOpen,
  approvalIsLoading,
}: Props) => {
  const f = useFormatMessage();

  return (
    <FloatingIsland visible={isVisible} testId="approve-reject-toolbar">
      <Stack gap="regularMedium" direction="row">
        <Button
          data-test-id="reject-button"
          variant="secondaryNegative"
          size="small"
          onClick={() => {
            handleRejectionModalOpen();
          }}
          icon={icons.cross}
        >
          {f('selection_recommendations.reject')}
        </Button>
        <Button
          data-test-id="approve-button"
          variant="primary"
          size="small"
          loading={approvalIsLoading}
          onClick={() => {
            handleApprovalModalOpen();
          }}
          icon={icons.checkmark}
        >
          {f('selection_recommendations.approve')}
        </Button>
      </Stack>
    </FloatingIsland>
  );
};
